// removed by extract-text-webpack-plugin
module.exports = {"dropdownLabel":"primaryDropdown__dropdownLabel--38btL","dropdownLabelTooltip":"primaryDropdown__dropdownLabelTooltip--pyaFH"};


//////////////////
// WEBPACK FOOTER
// ./src/app/components/FilterComponents/primaryDropdown.css
// module id = iflo
// module chunks = 1 2 3 4 6 7 8 12 15 16 17 18 19 20 22 26 28